module.exports = __webpack_public_path__ + "media/packs/landing_page/images/que_es-49236e06ef9a965827b9d428974aa0c8.png";